import '@mdi/font/css/materialdesignicons.css';
import 'vuetify/styles';
import { createVuetify } from 'vuetify';
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';
import { aliases, mdi } from 'vuetify/iconsets/mdi';

export default createVuetify({
  components,
  directives,
  // 未指定時の既定は 'system'（OS の prefers-color-scheme 追従）。
  // OS ダーク時に --v-theme-background が #121212 になるため light に固定する。
  theme: {
    defaultTheme: 'light',
  },
  defaults: {
    VRadio: { color: 'primary' },
    VCheckbox: { color: 'primary' },
    VRadioGroup: { color: 'primary' },
  },
  icons: {
    defaultSet: 'mdi',
    aliases,
    sets: { mdi },
  },
});
